import React from 'react';
import {Container, Button} from '../components.js';

class ModalContainer extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);

	}

	onClick(e) {
		if(this.props.onClick) this.props.onClick(e);
	}

	render() {
		var modalSize = {
			width: this.props.size ? this.props.size.width : '50vmin',
			height: this.props.size ? this.props.size.height : 'auto'
		};
		var additionalClass = this.props.visible ? ' Visible' : ' Hidden';
		var affirmativeLabel = this.props.affirmativeLabel || 'Okay';

		const cancelButton = (this.props.cancelShown) ? (<div className={"ModalButton-Cancel"}>
						<Button class="Cancel-Button" dataId="cancel" label="Cancel" onClick={() => {
								this.props.cancelCallback();
							}
						} />
					</div>) : '';

		var containerContents = (

			<div className={"ModalContents"}>
				{this.props.prompt}
				<div className={"ModalButtons-Col"}>
					<div className={"ModalButton-Affirmative"}>
						<Button class="Affirmative-Button" dataId="affirmative" label={affirmativeLabel} onClick={this.onClick} />
					</div>
					{cancelButton}
				</div>
			</div> 
		);

		return (
			<div className={"Modal" + additionalClass}>
				<Container size={modalSize} titles={[{label: this.props.header}]} contents={containerContents} bgcolor="#48a7e3" />
			</div>
		);
	}
}

export default ModalContainer;